import ApiService from './Api.service.js'

class ModuleService extends ApiService {
  getUserCourseProgress(moduleId, studentId) {
    return this.resource.get(`modules/${moduleId}/students/${studentId}/progress`)
  }

  getAllModulesTeacher(userId) {
    return this.resource.get(`teachers/${userId}/modules`)
  }

  copyModule(moduleOld, moduleNew) {
    return this.resource.get(`${moduleOld}/${moduleNew}/modules`)
  }

}

export default new ModuleService('modules')



// WEBPACK FOOTER //
// ./src/services/axios/module.service.js